(ns manage.content-configuration-page.placeholder-expression.macro-input
  (:require [common.trie :as trie]
            [lemonpi.content-function.shared.macro :as shared.macro]
            [manage.slate-editor.macro-input :as macro-input]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui macro-input [props]
  (let [dictionary (use-subscribe [:manage.content-configuration-page.placeholder-expression.db/macro-dictionary])]
    ($ macro-input/macro-input {:& props
                                :get-auto-complete-options (fn [macro-content-text]
                                                             (trie/prefix-matches macro-content-text dictionary))
                                :is-macro-valid? (fn [macro-content-text]
                                                   (some? (shared.macro/parse-macro (str "${" macro-content-text "}"))))})))

